/**
 * Encryption Constants
 *
 * Configuration values for the DM encryption at rest system.
 * These must match between client-side (Web Crypto API) and
 * server-side (Node.js crypto) implementations.
 */

/** AES-GCM authenticated encryption algorithm */
export const ENCRYPTION_ALGORITHM = 'AES-GCM';

/** Key length in bits (256-bit AES) */
export const KEY_LENGTH = 256;

/** Initialization vector length in bytes (96-bit IV for AES-GCM) */
export const IV_LENGTH = 12;

/** HKDF info string for per-conversation key derivation */
export const HKDF_INFO = 'sos-encryption-v1';

/** HKDF hash algorithm */
export const HKDF_HASH = 'SHA-256';

/** Placeholder shown in admin views and for non-participants */
export const ENCRYPTED_PLACEHOLDER = '[Encrypted]';

/** Shown when decryption fails (wrong key, corrupt data, etc.) */
export const DECRYPT_FAILED_PLACEHOLDER = '[Unable to decrypt]';

/** Shown briefly while async decryption is in progress */
export const DECRYPTING_PLACEHOLDER = 'Decrypting...';

/** Name of the Cloud Function that provides the encryption key */
export const GET_ENCRYPTION_KEY_FUNCTION = 'getEncryptionKey';
